export default __webpack_public_path__ + "static/logo-2996ef2df7d011630e15eeffdea07cb8.png";